import availableColors from './availableColors.json';

const generateRandomColor = () => {
  return availableColors[Math.floor(Math.random() * availableColors.length)];
};

export default generateRandomColor;
